import { Fragment } from "react";
import { Href } from "../../../../../../Constants/Constants";
import { ChatFriendContent } from "../../../../../../Data/Messenger/Messenger";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { OpenAppSidebar } from "../../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import useOutside from "../../../../../../Utils/useOutside";
import SvgIcon from "../../../../../CommonComponents/SvgIcon";

const QuickAction = () => {
  const { ref, isComponentVisible, setIsComponentVisible } = useOutside(false);
  const dispatch = useAppDispatch();
  return (
    <Fragment>
      <li>
        <a className="icon-btn button-effect apps-toggle" href={Href} onClick={() => dispatch(OpenAppSidebar())}>
          <SvgIcon className="stroke-primary" iconId="toggle-grid" />
        </a>
      </li>
      <li ref={ref} className={`icon-btn chat-friend-toggle ${isComponentVisible && "active"}`}>
        <a className="icon-btn rouded15 button-effect outside" href={Href} onClick={() => setIsComponentVisible(!isComponentVisible)}>
          <SvgIcon className="fill-primary" iconId="header-toggle" />
        </a>
        <div className={`chat-frind-content ${isComponentVisible ? "d-block" : "d-none"}`}>
          <ul>
            {ChatFriendContent.map((item, index) => (
              <li key={index}>
                <a href={Href}>
                  <SvgIcon className={item.class} iconId={item.icon} />
                </a>
                <h5>{item.title}</h5>
              </li>
            ))}
          </ul>
        </div>
      </li>
    </Fragment>
  );
};

export default QuickAction;
